/* TextInput: a labelled one-line text box in the shared Field look.
 *
 *   <TextInput label="Vessel name" value={v} onChange={(e) => set(e.target.value)} />
 *
 * Shared field props (same on every ui/fields control):
 *   label, hint, error, required, disabled, id (generated when omitted),
 *   fieldClassName (on the .hms-field wrapper), className (on the input).
 * Everything else (value, onChange, name, placeholder, type, autoComplete,
 * data-*, aria-*) passes straight through to the <input>, and the ref
 * lands on it too.
 */
import React, { forwardRef } from 'react';
import Field from '../Field';
import useFieldControl, { cx, splitAria } from './useFieldControl';

const TextInput = forwardRef(function TextInput(
  {
    label,
    hint,
    error,
    required = false,
    disabled = false,
    id,
    className,
    fieldClassName,
    type = 'text',
    ...props
  },
  ref
) {
  const [aria, rest] = splitAria(props);
  const { fieldProps, controlProps } = useFieldControl({ id, hint, error, required, aria });

  return (
    <Field
      label={label}
      hint={hint}
      error={error}
      required={required}
      className={fieldClassName}
      {...fieldProps}
    >
      <input
        {...rest}
        {...controlProps}
        ref={ref}
        type={type}
        disabled={disabled}
        className={cx('hms-input', className)}
      />
    </Field>
  );
});

export default TextInput;
